import AddIcon from "@mui/icons-material/Add";
import {
  Avatar,
  Button,
  Card,
  CardContent,
  Container,
  FormControl,
  FormControlLabel,
  FormGroup,
  ListItem,
  ListItemButton,
  Paper,
  Stack,
  Switch,
  Typography,
} from "@mui/material";
import TextField from "@mui/material/TextField";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import CustomizedBreadcrumbs from "../../component/breadcrumbs/breadcrumbs";
import ResponsiveDialog from "../../component/dialog/dialog";
import DrawerPrincipal from "../../component/drawer/drawer-principal";
import { usePermissions } from "../../contexts/permissionsContext";
import usePermissionCheck from "../../hooks/usePermissionCheck";
import { getErrorMessage } from "../../service/api";
import userService from "../../service/serviceUser";

function NewUser() {
  const { getPermission, refreshPermissions } = usePermissions();
  const { checkPermissionWithRefresh, permissionError, clearPermissionError } = usePermissionCheck();

  // Obter permissão de Usuário do sistema centralizado
  const permission = getPermission("Usuario");

  const [name, setName] = useState("");
  const [nameError, setNameError] = useState("");

  const [login, setLogin] = useState("");
  const [loginError, setLoginError] = useState("");

  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [originalPassword, setOriginalPassword] = useState("");

  const [comissao, setComissao] = useState("");
  const [comissaoError, setComissaoError] = useState("");

  const [openDialog, setOpenDialog] = useState(false);
  const [messageDialog, setMessageDialog] = useState("");
  const [titleDialog, setTitleDialog] = useState("");
  const [statusDialog, setStatusDialog] = useState("");

  const [idRoleUser, setIdRoleUser] = useState();
  const [checkUserInsert, setCheckUserInsert] = useState(false);
  const [checkUserList, setCheckUserList] = useState(false);
  const [checkUserRemove, setCheckUserRemove] = useState(false);

  const [idRoleClient, setIdRoleClient] = useState();
  const [checkCliInsert, setCheckCliInsert] = useState(false);
  const [checkCliList, setCheckCliList] = useState(false);
  const [checkCliRemove, setCheckCliRemove] = useState(false);

  const [idRoleService, setIdRoleService] = useState();
  const [checkServiceInsert, setCheckServiceInsert] = useState(false);
  const [checkServiceList, setCheckServiceList] = useState(false);
  const [checkServiceRemove, setCheckServiceRemove] = useState(false);

  const [idRolePainel, setIdRolePainel] = useState();
  const [checkPainelInsert, setCheckPainelInsert] = useState(false);
  const [checkPainelList, setCheckPainelList] = useState(false);
  const [checkPainelRemove, setCheckPainelRemove] = useState(false);

  const [idRoleCircuit, setIdRoleCircuit] = useState();
  const [checkCircuitInsert, setCheckCircuitInsert] = useState(false);
  const [checkCircuitList, setCheckCircuitList] = useState(false);
  const [checkCircuitRemove, setCheckCircuitRemove] = useState(false);

  const [idRoleVenda, setIdRoleVenda] = useState();
  const [checkVendaInsert, setCheckVendaInsert] = useState(false);
  const [checkVendaList, setCheckVendaList] = useState(false);
  const [checkVendaRemove, setCheckVendaRemove] = useState(false);

  const [idRoleEnviaVenda, setIdRoleEnviaVenda] = useState();
  const [checkEnviaVendaInsert, setCheckEnviaVendaInsert] = useState(false);

  const [idRoleReabrirVenda, setIdRoleReabrirVenda] = useState();
  const [checkReabrirVenda, setCheckReabrirVenda] = useState(false);

  const [idRoleEditarVenda, setIdRoleEditarVenda] = useState();
  const [checkEditarVenda, setCheckEditarVenda] = useState(false);

  const [idRoleDashboard, setIdRoleDashboard] = useState();
  const [checkDashboard, setCheckDashboard] = useState(false);

  const [idRoleDashboardScp, setIdRoleDashboardScp] = useState();
  const [checkDashboardScp, setCheckDashboardScp] = useState(false);

  const [idRoleSuport, setIdRoleSuport] = useState();
  const [checkSuport, setCheckSuport] = useState(false);
  
  // Configuração
  const [idRoleConfiguration, setIdRoleConfiguration] = useState();
  const [checkConfiguration, setCheckConfiguration] = useState(false);
  const [checkConfigurationList, setCheckConfigurationList] = useState(false);
  const [checkConfigurationRemove, setCheckConfigurationRemove] = useState(false);

  // Escrituracao Nota Fiscal (nome da permissão no backend)
  const [idRoleEscrituracaoNotaFiscal, setIdRoleEscrituracaoNotaFiscal] = useState();
  const [checkEscrituracaoNotaFiscal, setCheckEscrituracaoNotaFiscal] = useState(false);

  const { id } = useParams();

  let navigate = useNavigate();

  useEffect(() => {
    (async () => {
      if (id) {
        try {
          const response = await userService.editUser(id);
          if (
            response.status === 200 ||
            response.status === 201 ||
            response.success === true
          ) {
            const item = response.data;

            setName(item.name);
            setLogin(item.login);
            setPassword(""); // Campo vazio para nova senha
            setOriginalPassword(item.password || ""); // Armazenar senha original com fallback
            setComissao(item.comissao || ""); // Carregar comissão do usuário

            item.roles.forEach((element) => {
              if (element.name === "Usuario") {
                setIdRoleUser(element.idroles);
                setCheckUserInsert(element.isinsert);
                setCheckUserList(element.islist);
                setCheckUserRemove(element.isremove);
              }

              if (element.name === "Cliente") {
                setIdRoleClient(element.idroles);
                setCheckCliInsert(element.isinsert);
                setCheckCliList(element.islist);
                setCheckCliRemove(element.isremove);
              }

              if (element.name === "Serviço") {
                setIdRoleService(element.idroles);
                setCheckServiceInsert(element.isinsert);
                setCheckServiceList(element.islist);
                setCheckServiceRemove(element.isremove);
              }

              if (element.name === "Painel") {
                setIdRolePainel(element.idroles);
                setCheckPainelInsert(element.isinsert);
                setCheckPainelList(element.islist);
                setCheckPainelRemove(element.isremove);
              }

              if (element.name === "Circuito") {
                setIdRoleCircuit(element.idroles);
                setCheckCircuitInsert(element.isinsert);
                setCheckCircuitList(element.islist);
                setCheckCircuitRemove(element.isremove);
              }

              if (element.name === "Vendas") {
                setIdRoleVenda(element.idroles);
                setCheckVendaInsert(element.isinsert);
                setCheckVendaList(element.islist);
                setCheckVendaRemove(element.isremove);
              }
              if (element.name === "Enviar Vendas") {
                setIdRoleEnviaVenda(element.idroles);
                setCheckEnviaVendaInsert(element.isinsert);
              }

              if (element.name === "Reabrir Vendas") {
                setIdRoleReabrirVenda(element.idroles);
                setCheckReabrirVenda(element.isinsert);
              }

              if (element.name === "Editar Datas") {
                setIdRoleEditarVenda(element.idroles);
                setCheckEditarVenda(element.isinsert);
              }

              if (element.name === "Dashboard") {
                setIdRoleDashboard(element.idroles);
                setCheckDashboard(element.isinsert);
              }

              if (element.name === "Dashboard SCP") {
                setIdRoleDashboardScp(element.idroles);
                setCheckDashboardScp(element.isinsert);
              }

              if (element.name === "Suporte") {
                setIdRoleSuport(element.idroles);
                setCheckSuport(element.isinsert);
              }

              if (element.name === "Configuração") {
                setIdRoleConfiguration(element.idroles);
                setCheckConfiguration(element.isinsert);
                setCheckConfigurationList(element.islist);
                setCheckConfigurationRemove(element.isremove);
              }

              // Atenção: o nome da permissão no backend é "Escrituracao Nota Fiscal" (sem acento)
              if (element.name === "Escrituracao Nota Fiscal") {
                setIdRoleEscrituracaoNotaFiscal(element.idroles);
                setCheckEscrituracaoNotaFiscal(element.isinsert);
              }
            });
          } else {
            setOpenDialog(true);
            setStatusDialog("error");
            setTitleDialog("Ops!");
            setMessageDialog(
              getErrorMessage(response) || "Erro ao buscar usuário"
            );
          }
        } catch (error) {
          setOpenDialog(true);
          setStatusDialog("error");
          setTitleDialog("Ops!");
          setMessageDialog(getErrorMessage(error) || "Erro ao buscar usuário");
        }
      }
    })();
  }, [id]);


  async function save() {
    try {
      // Verificar permissão antes de salvar
      const hasPermission = await checkPermissionWithRefresh("Usuario", "isinsert", true, false);
      if (!hasPermission) {
        return; // A função checkPermissionWithRefresh já mostra o dialog de erro
      }

      if (valid()) {
        var listRoles = [];

        var roleUser = {
          idroles: idRoleUser,
          name: "Usuario",
          isinsert: checkUserInsert,
          islist: checkUserList,
          isremove: checkUserRemove,
        };

        listRoles.push(roleUser);

        var roleCli = {
          idroles: idRoleClient,
          name: "Cliente",
          isinsert: checkCliInsert,
          islist: checkCliList,
          isremove: checkCliRemove,
        };

        listRoles.push(roleCli);

        var rolePanel = {
          idroles: idRolePainel,
          name: "Painel",
          isinsert: checkPainelInsert,
          islist: checkPainelList,
          isremove: checkPainelRemove,
        };

        listRoles.push(rolePanel);

        var roleService = {
          idroles: idRoleService,
          name: "Serviço",
          isinsert: checkServiceInsert,
          islist: checkServiceList,
          isremove: checkServiceRemove,
        };

        listRoles.push(roleService);

        var roleCircuit = {
          idroles: idRoleCircuit,
          name: "Circuito",
          isinsert: checkCircuitInsert,
          islist: checkCircuitList,
          isremove: checkCircuitRemove,
        };

        listRoles.push(roleCircuit);

        var roleVenda = {
          idroles: idRoleVenda,
          name: "Vendas",
          isinsert: checkVendaInsert,
          islist: checkVendaList,
          isremove: checkVendaRemove,
        };

        listRoles.push(roleVenda);

        var roleEnviarVenda = {
          idroles: idRoleEnviaVenda,
          name: "Enviar Vendas",
          isinsert: checkEnviaVendaInsert,
        };

        listRoles.push(roleEnviarVenda);

        var roleReabrirVenda = {
          idroles: idRoleEnviaVenda,
          name: "Reabrir Vendas",
          isinsert: checkReabrirVenda,
        };

        listRoles.push(roleReabrirVenda);

        var roleEditarVenda = {
          idroles: idRoleEditarVenda,
          name: "Editar Datas",
          isinsert: checkEditarVenda,
        };

        listRoles.push(roleEditarVenda);

        var roleDashboard = {
          idroles: idRoleDashboard,
          name: "Dashboard",
          isinsert: checkDashboard,
        };

        listRoles.push(roleDashboard);

        var roleDashboardScp = {
          idroles: idRoleDashboardScp,
          name: "Dashboard SCP",
          isinsert: checkDashboardScp,
        };

        listRoles.push(roleDashboardScp);

        var roleSuport = {
          idroles: idRoleSuport,
          name: "Suporte",
          isinsert: checkSuport,
        };

        listRoles.push(roleSuport);

        var roleConfiguration = {
          idroles: idRoleConfiguration,
          name: "Configuração",
          isinsert: checkConfiguration,
          islist: checkConfigurationList,
          isremove: checkConfigurationRemove,
        };

        listRoles.push(roleConfiguration);

        var roleEscrituracaoNotaFiscal = {
          idroles: idRoleEscrituracaoNotaFiscal,
          name: "Escrituracao Nota Fiscal",
          isinsert: checkEscrituracaoNotaFiscal,
        };

        listRoles.push(roleEscrituracaoNotaFiscal);

        var data = {
          name: name,
          login: login,
          password: getPasswordToUse(),
          comissao: comissao || null,
          roles: listRoles,
        };

        const response = await userService.save(data);
        if (
          response.status === 200 ||
          response.status === 201 ||
          response.success === true
        ) {
          setOpenDialog(true);
          setStatusDialog("success");
          setTitleDialog("Muito bem!");
          setMessageDialog("Usuário cadastrado com sucesso");
        } else {
          setOpenDialog(true);
          setStatusDialog("error");
          setTitleDialog("Ops");
          setMessageDialog(response.message || "Erro ao cadastrar usuário");
        }
      }
    } catch (error) {
      setOpenDialog(true);
      setStatusDialog("error");
      setTitleDialog("Ops");
      setMessageDialog(error.message || "Erro ao cadastrar usuário");
    }
  }

  async function update() {
    try {
      // Verificar permissão antes de atualizar
      const hasPermission = await checkPermissionWithRefresh("Usuario", "isinsert", true, false);
      if (!hasPermission) {
        return; // A função checkPermissionWithRefresh já mostra o dialog de erro
      }

      if (valid()) {
        var listRoles = [];

        var roleUser = {
          idroles: idRoleUser,
          isinsert: checkUserInsert,
          islist: checkUserList,
          isremove: checkUserRemove,
        };

        listRoles.push(roleUser);

        var roleCli = {
          idroles: idRoleClient,
          isinsert: checkCliInsert,
          islist: checkCliList,
          isremove: checkCliRemove,
        };

        listRoles.push(roleCli);

        var rolePanel = {
          idroles: idRolePainel,
          isinsert: checkPainelInsert,
          islist: checkPainelList,
          isremove: checkPainelRemove,
        };

        listRoles.push(rolePanel);

        var roleService = {
          idroles: idRoleService,
          isinsert: checkServiceInsert,
          islist: checkServiceList,
          isremove: checkServiceRemove,
        };

        listRoles.push(roleService);

        var roleCircuit = {
          idroles: idRoleCircuit,
          isinsert: checkCircuitInsert,
          islist: checkCircuitList,
          isremove: checkCircuitRemove,
        };

        listRoles.push(roleCircuit);

        var roleVenda = {
          idroles: idRoleVenda,
          name: "Vendas",
          isinsert: checkVendaInsert,
          islist: checkVendaList,
          isremove: checkVendaRemove,
        };
        listRoles.push(roleVenda);

        var roleEnviarVenda = {
          idroles: idRoleEnviaVenda,
          name: "Enviar Vendas",
          isinsert: checkEnviaVendaInsert,
        };

        listRoles.push(roleEnviarVenda);

        var roleReabrirVenda = {
          idroles: idRoleReabrirVenda,
          name: "Reabrir Vendas",
          isinsert: checkReabrirVenda,
        };

        listRoles.push(roleReabrirVenda);

        var roleEditarVenda = {
          idroles: idRoleEditarVenda,
          name: "Editar Datas",
          isinsert: checkEditarVenda,
        };

        listRoles.push(roleEditarVenda);

        var roleDashboard = {
          idroles: idRoleDashboard,
          name: "Dashboard",
          isinsert: checkDashboard,
        };

        listRoles.push(roleDashboard);

        var roleDashboardScp = {
          idroles: idRoleDashboardScp,
          name: "Dashboard SCP",
          isinsert: checkDashboardScp,
        };

        listRoles.push(roleDashboardScp);

        var roleSuport = {
          idroles: idRoleSuport,
          name: "Suporte",
          isinsert: checkSuport,
        };

        listRoles.push(roleSuport);

        var roleConfiguration = {
          idroles: idRoleConfiguration,
          name: "Configuração",
          isinsert: checkConfiguration,
          islist: checkConfigurationList,
          isremove: checkConfigurationRemove,
        };

        listRoles.push(roleConfiguration);

        var roleEscrituracaoNotaFiscal = {
          idroles: idRoleEscrituracaoNotaFiscal,
          name: "Escrituracao Nota Fiscal",
          isinsert: checkEscrituracaoNotaFiscal,
        };

        listRoles.push(roleEscrituracaoNotaFiscal);

        var data = {
          iduser: id,
          name: name,
          login: login,
          password: getPasswordToUse(),
          comissao: comissao || null,
          roles: listRoles,
        };

        const response = await userService.update(data);
        if (
          response.status === 200 ||
          response.status === 201 ||
          response.success === true
        ) {
          setOpenDialog(true);
          setStatusDialog("success");
          setTitleDialog("Muito bem!");
          setMessageDialog("Usuário atualizado com sucesso");

        } else {
          setOpenDialog(true);
          setStatusDialog("error");
          setTitleDialog("Ops");
          setMessageDialog(response.message || "Erro ao atualizar usuário");
        }
      }
    } catch (error) {
      setOpenDialog(true);
      setStatusDialog("error");
      setTitleDialog("Ops");
      setMessageDialog(error.message || "Erro ao atualizar usuário");
    }
  }

  /**
   * @function getPasswordToUse
   * @description Determina qual senha deve ser enviada para o backend baseado no contexto (novo usuário ou edição).
   * Para novos usuários: retorna a senha digitada (obrigatória).
   * Para usuários existentes: retorna nova senha se digitada, senão mantém a senha original.
   * Inclui validações para prevenir senhas vazias e logs de warning para debug.
   * @returns {string} A senha a ser utilizada na operação (nova ou original)
   */
  const getPasswordToUse = () => {
    if (!id) {
      // Para novos usuários, senha é obrigatória
      return password && password.trim() !== "" ? password : "";
    } else {
      // Para usuários existentes, se não foi digitada nova senha, manter a original
      if (password && password.trim() !== "") {
        return password; // Nova senha foi digitada
      } else {
        // Verificar se temos uma senha original válida
        if (!originalPassword || originalPassword.trim() === "") {
          console.warn("⚠️ Senha original não encontrada ou vazia para usuário ID:", id);
          // Se não há senha original e não foi digitada nova, retornar string vazia
          // O backend deve tratar isso adequadamente
          return "";
        }
        return originalPassword; // Manter senha original
      }
    }
  };

  function valid() {
    let message = "Este campo é obrigatório";
    let thatsOk = true;

    if (!name) {
      setNameError(message);
      thatsOk = false;
    }
    if (!login) {
      setLoginError(message);
      thatsOk = false;
    }
    if (!id && (!password || password.trim() === "")) {
      setPasswordError(message);
      thatsOk = false;
    }
    
    // Validar comissão (opcional, mas se preenchida deve ser um número válido)
    if (comissao && (isNaN(comissao) || parseFloat(comissao) < 0 || parseFloat(comissao) > 100)) {
      setComissaoError("A comissão deve ser um número entre 0 e 100");
      thatsOk = false;
    }

    return thatsOk;
  }

  const handleDialogClose = async () => {
    setOpenDialog(false);
    // Se foi sucesso, navegar para a lista de usuários após fechar o dialog
    if (statusDialog === "success") {
      await refreshPermissions();
      navigate("/user");
    }
  };

  return (
    <>
      <Container maxWidth="lx" sx={{ bgcolor: "#EBEBEB" }}>
        <DrawerPrincipal
          divOpen={
            <div>
              <div>
                <div className="row mb-3">
                  <CustomizedBreadcrumbs
                    title1={"Home"}
                    link1={"/"}
                    title2={"Lista de Usuários"}
                    link2={"#"}
                    title3={"Cadastro de Usuário"}
                    link3={"#"}
                  />
                </div>
                <ResponsiveDialog
                  open={openDialog}
                  handleClose={handleDialogClose}
                  title={titleDialog}
                  message={messageDialog}
                  status={statusDialog}
                />

                <div className="row">
                  <h1 className="h3 mb-3 text-black font-weight-bold">
                    Cadastro de usuário
                  </h1>
                </div>

                <Paper sx={{ width: "100%", overflow: "hidden", padding: 2 }}>
                  <div className="container">
                    <div className="row">
                      <div className="col-3">
                        <Card>
                          <div className="form-signin mx-auto mb-4 mb-lg-6">
                            <div className="row">
                              <CardContent>
                                <div className="row">
                                  <Stack
                                    direction="row"
                                    spacing={2}
                                    style={{ paddingLeft: 50 }}
                                  >
                                    <Avatar
                                      alt="Profile"
                                      sx={{ width: 150, height: 150 }}
                                      src={
                                        "https://developerplus.com.br/wp-content/uploads/2021/10/user.png"
                                      }
                                    />
                                  </Stack>
                                </div>
                                <div className="row">
                                  <Typography variant="h8" sx={{ padding: 2 }}>
                                    {name}
                                  </Typography>
                                </div>
                              </CardContent>
                            </div>
                          </div>
                        </Card>
                      </div>
                      <div className="col-8">
                        <Card>
                          <div
                            className="form-cadastro"
                            style={{ padding: 20 }}
                          >
                            <div className="row">
                              <div className="col-md-8 mb-3">
                                <TextField
                                  fullWidth
                                  label={
                                    name ? "Nome do usuário" : "Nome do usuário"
                                  }
                                  id="outlined-size"
                                  focused={!!name}
                                  size="small"
                                  value={name || ""}
                                  onChange={(e) => {
                                    setName(e.target.value);
                                    setNameError("");
                                  }}
                                  error={!!nameError}
                                  helperText={nameError ? nameError : ""}
                                />
                              </div>

                              <div className="row mb-3">
                                <div className="col-md-4">
                                  <TextField
                                    fullWidth
                                    focused={!!login}
                                    label="Login"
                                    id="outlined--small"
                                    size="small"
                                    value={login || ""}
                                    onChange={(e) => {
                                      setLogin(e.target.value);
                                      setLoginError("");
                                    }}
                                    error={!!loginError}
                                    helperText={loginError ? loginError : ""}
                                  />
                                </div>
                                <div className="col-md-4">
                                  <TextField
                                    fullWidth
                                    focused={!!comissao}
                                    label="Comissão (%)"
                                    id="outlined-comissao"
                                    size="small"
                                    value={comissao || ""}
                                    onChange={(e) => {
                                      // Permitir apenas números e ponto
                                      const value = e.target.value.replace(/[^0-9.]/g, '');
                                      setComissao(value);
                                      setComissaoError("");
                                    }}
                                    error={!!comissaoError}
                                    helperText={comissaoError ? comissaoError : "Informe a comissão em percentual"}
                                  />
                                </div>
                                <div className="col-md-4">
                                  <TextField
                                    fullWidth
                                    focused={!!password}
                                    label="Nova senha"
                                    id="outlined-size-small"
                                    size="small"
                                    type="password"
                                    value={password || ""}
                                    onChange={(e) => {
                                      setPassword(e.target.value);
                                      setPasswordError("");
                                    }}
                                    error={!!passwordError}
                                    helperText={
                                      passwordError ? passwordError : ""
                                    }
                                    autoComplete="off"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </Card>

                        <div style={{ padding: 5 }}></div>

                        <Card>
                          <div className="container" style={{ paddingTop: 20 }}>
                            <div className="row">
                              <div className="col-3">
                                <div className="form-signin mx-auto mb-4 ">
                                  <h5>Permissões</h5>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div
                            className="form-cadastro"
                            style={{ padding: 20 }}
                          >
                            <div className="row">
                              <div className="col-md-4">
                                <h6>
                                  Usuários
                                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </h6>
                              </div>
                            </div>
                            <ListItemButton key={"user-insert"} role="listitem">
                              <FormControl
                                component="fieldset"
                                variant="standard"
                              >
                                <FormGroup>
                                  <FormControlLabel
                                    control={
                                      <Switch
                                        checked={checkUserInsert ? true : false}
                                        onClick={(e) =>
                                          setCheckUserInsert(e.target.checked)
                                        }
                                        name="Cadastrar usuários"
                                      />
                                    }
                                    label="Cadastrar usuários"
                                  />
                                </FormGroup>
                              </FormControl>
                            </ListItemButton>
                            <ListItemButton key={"user-list"} role="listitem">
                              <FormControl
                                component="fieldset"
                                variant="standard"
                              >
                                <FormGroup>
                                  <FormControlLabel
                                    control={
                                      <Switch
                                        checked={checkUserList ? true : false}
                                        onClick={(e) =>
                                          setCheckUserList(e.target.checked)
                                        }
                                        name="Listar usuário"
                                      />
                                    }
                                    label="Listar usuário"
                                  />
                                </FormGroup>
                              </FormControl>
                            </ListItemButton>

                            <ListItemButton key={"user-remove"} role="listitem">
                              <FormControl
                                component="fieldset"
                                variant="standard"
                              >
                                <FormGroup>
                                  <FormControlLabel
                                    control={
                                      <Switch
                                        checked={checkUserRemove ? true : false}
                                        onClick={(e) =>
                                          setCheckUserRemove(e.target.checked)
                                        }
                                        name="Excluir usuário"
                                      />
                                    }
                                    label="Excluir usuário"
                                  />
                                </FormGroup>
                              </FormControl>
                            </ListItemButton>
                          </div>

                          <div
                            className="form-cadastro"
                            style={{ padding: 20 }}
                          >
                            <div className="row">
                              <div className="col-md-4">
                                <h6>
                                  Cliente
                                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </h6>
                              </div>
                            </div>
                            <ListItemButton key={"client-insert"} role="listitem">
                              <FormControl
                                component="fieldset"
                                variant="standard"
                              >
                                <FormGroup>
                                  <FormControlLabel
                                    control={
                                      <Switch
                                        checked={checkCliInsert ? true : false}
                                        onClick={(e) =>
                                          setCheckCliInsert(e.target.checked)
                                        }
                                        name="Cadastrar cliente"
                                      />
                                    }
                                    label="Cadastrar cliente"
                                  />
                                </FormGroup>
                              </FormControl>
                            </ListItemButton>
                            <ListItemButton key={"client-list"} role="listitem">
                              <FormGroup>
                                <FormControlLabel
                                  control={
                                    <Switch
                                      checked={checkCliList ? true : false}
                                      onClick={(e) =>
                                        setCheckCliList(e.target.checked)
                                      }
                                      name="Listar Cliente"
                                    />
                                  }
                                  label="Listar cliente"
                                />
                              </FormGroup>
                            </ListItemButton>

                            <ListItemButton key={"client-remove"} role="listitem">
                              <FormGroup>
                                <FormControlLabel
                                  control={
                                    <Switch
                                      checked={checkCliRemove ? true : false}
                                      onClick={(e) =>
                                        setCheckCliRemove(e.target.checked)
                                      }
                                      name="Excluir usuário"
                                    />
                                  }
                                  label="Excluir usuário"
                                />
                              </FormGroup>
                            </ListItemButton>
                          </div>

                          <div
                            className="form-cadastro"
                            style={{ padding: 20 }}
                          >
                            <div className="row">
                              <div className="col-md-4">
                                <h6>
                                  Serviço
                                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </h6>
                              </div>
                            </div>
                            <ListItemButton key={"service-insert"} role="listitem">
                              <FormGroup>
                                <FormControlLabel
                                  control={
                                    <Switch
                                      checked={
                                        checkServiceInsert ? true : false
                                      }
                                      onClick={(e) =>
                                        setCheckServiceInsert(e.target.checked)
                                      }
                                      name="Cadastrar serviço"
                                    />
                                  }
                                  label="Cadastrar serviço"
                                />
                              </FormGroup>
                            </ListItemButton>
                            <ListItemButton key={"service-list"} role="listitem">
                              <FormGroup>
                                <FormControlLabel
                                  control={
                                    <Switch
                                      checked={checkServiceList ? true : false}
                                      onClick={(e) =>
                                        setCheckServiceList(e.target.checked)
                                      }
                                      name="Listar serviço"
                                    />
                                  }
                                  label="Listar serviço"
                                />
                              </FormGroup>
                            </ListItemButton>

                            <ListItemButton key={"service-remove"} role="listitem">
                              <FormGroup>
                                <FormControlLabel
                                  control={
                                    <Switch
                                      checked={
                                        checkServiceRemove ? true : false
                                      }
                                      onClick={(e) =>
                                        setCheckServiceRemove(e.target.checked)
                                      }
                                      name="Excluir serviço"
                                    />
                                  }
                                  label="Excluir serviço"
                                />
                              </FormGroup>
                            </ListItemButton>
                          </div>

                          <div
                            className="form-cadastro"
                            style={{ padding: 20 }}
                          >
                            <div className="row">
                              <div className="col-md-4">
                                <h6>
                                  Painel
                                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </h6>
                              </div>
                            </div>
                            <ListItemButton key={"panel-insert"} role="listitem">
                              <FormGroup>
                                <FormControlLabel
                                  control={
                                    <Switch
                                      checked={checkPainelInsert ? true : false}
                                      onClick={(e) =>
                                        setCheckPainelInsert(e.target.checked)
                                      }
                                      name="Cadastrar serviço"
                                    />
                                  }
                                  label="Cadastrar serviço"
                                />
                              </FormGroup>
                            </ListItemButton>
                            <ListItemButton key={"panel-list"} role="listitem">
                              <FormGroup>
                                <FormControlLabel
                                  control={
                                    <Switch
                                      checked={checkPainelList ? true : false}
                                      onClick={(e) =>
                                        setCheckPainelList(e.target.checked)
                                      }
                                      name="Listar painel"
                                    />
                                  }
                                  label="Listar painel"
                                />
                              </FormGroup>
                            </ListItemButton>

                            <ListItemButton key={"panel-remove"} role="listitem">
                              <FormGroup>
                                <FormControlLabel
                                  control={
                                    <Switch
                                      checked={checkPainelRemove ? true : false}
                                      onClick={(e) =>
                                        setCheckPainelRemove(e.target.checked)
                                      }
                                      name="Excluir painel"
                                    />
                                  }
                                  label="Excluir painel"
                                />
                              </FormGroup>
                            </ListItemButton>
                          </div>

                          <div
                            className="form-cadastro"
                            style={{ padding: 20 }}
                          >
                            <div className="row">
                              <div className="col-md-4">
                                <h6>
                                  Circuito
                                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </h6>
                              </div>
                            </div>
                            <ListItemButton key={"circuit-insert"} role="listitem">
                              <FormGroup>
                                <FormControlLabel
                                  control={
                                    <Switch
                                      checked={
                                        checkCircuitInsert ? true : false
                                      }
                                      onClick={(e) =>
                                        setCheckCircuitInsert(e.target.checked)
                                      }
                                      name="Cadastrar Circuito"
                                    />
                                  }
                                  label="Cadastrar Circuito"
                                />
                              </FormGroup>
                            </ListItemButton>
                            <ListItemButton key={"circuit-list"} role="listitem">
                              <FormGroup>
                                <FormControlLabel
                                  control={
                                    <Switch
                                      checked={checkCircuitList ? true : false}
                                      onClick={(e) =>
                                        setCheckCircuitList(e.target.checked)
                                      }
                                      name="Listar Circuito"
                                    />
                                  }
                                  label="Listar Circuito"
                                />
                              </FormGroup>
                            </ListItemButton>

                            <ListItemButton key={"circuit-remove"} role="listitem">
                              <FormGroup>
                                <FormControlLabel
                                  control={
                                    <Switch
                                      checked={
                                        checkCircuitRemove ? true : false
                                      }
                                      onClick={(e) =>
                                        setCheckCircuitRemove(e.target.checked)
                                      }
                                      name="Excluir Circuito"
                                    />
                                  }
                                  label="Excluir Circuito"
                                />
                              </FormGroup>
                            </ListItemButton>
                          </div>

                          <div
                            className="form-cadastro"
                            style={{ padding: 20 }}
                          >
                            <div className="row">
                              <div className="col-md-4">
                                <h6>
                                  Vendas
                                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </h6>
                              </div>
                            </div>
                            <ListItemButton key={"venda-insert"} role="listitem">
                              <FormGroup>
                                <FormControlLabel
                                  control={
                                    <Switch
                                      checked={checkVendaInsert ? true : false}
                                      onClick={(e) =>
                                        setCheckVendaInsert(e.target.checked)
                                      }
                                      name="Cadastrar Venda"
                                    />
                                  }
                                  label="Cadastrar Venda"
                                />
                              </FormGroup>
                            </ListItemButton>
                            <ListItemButton key={"l"} role="listitem">
                              <FormGroup>
                                <FormControlLabel
                                  control={
                                    <Switch
                                      checked={checkVendaList ? true : false}
                                      onClick={(e) =>
                                        setCheckVendaList(e.target.checked)
                                      }
                                      name="Listar Venda"
                                    />
                                  }
                                  label="Listar Venda"
                                />
                              </FormGroup>
                            </ListItemButton>

                            <ListItemButton key={"venda-remove"} role="listitem">
                              <FormGroup>
                                <FormControlLabel
                                  control={
                                    <Switch
                                      checked={checkVendaRemove ? true : false}
                                      onClick={(e) =>
                                        setCheckVendaRemove(e.target.checked)
                                      }
                                      name="Excluir Venda"
                                    />
                                  }
                                  label="Excluir Venda"
                                />
                              </FormGroup>
                            </ListItemButton>
                          </div>

                          <div
                            className="form-cadastro"
                            style={{ padding: 20 }}
                          >
                            <div className="row">
                              <div className="col-md-4">
                                <h6>
                                  Integração
                                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </h6>
                              </div>
                            </div>
                            <ListItem key={"venda-enviar"} role="listitem" button>
                              <FormGroup>
                                <FormControlLabel
                                  control={
                                    <Switch
                                      checked={
                                        checkEnviaVendaInsert ? true : false
                                      }
                                      onClick={(e) =>
                                        setCheckEnviaVendaInsert(
                                          e.target.checked
                                        )
                                      }
                                      name="Integrar venda"
                                    />
                                  }
                                  label="Integrar venda"
                                />
                              </FormGroup>
                            </ListItem>
                            <ListItem>
                              <FormGroup>
                                <FormControlLabel
                                  control={
                                    <Switch
                                      checked={checkReabrirVenda ? true : false}
                                      onClick={(e) =>
                                        setCheckReabrirVenda(e.target.checked)
                                      }
                                      name="Reabrir venda"
                                    />
                                  }
                                  label="Reabrir venda"
                                />
                              </FormGroup>
                            </ListItem>
                            <ListItem>
                              <FormGroup>
                                <FormControlLabel
                                  control={
                                    <Switch
                                      checked={checkEditarVenda ? true : false}
                                      onClick={(e) =>
                                        setCheckEditarVenda(e.target.checked)
                                      }
                                      name="Editar Datas"
                                    />
                                  }
                                  label="Editar Datas"
                                />
                              </FormGroup>
                            </ListItem>
                            <ListItem key={"suporte"} role="listitem" button>
                              <FormGroup>
                                <FormControlLabel
                                  control={
                                    <Switch
                                      checked={checkSuport ? true : false}
                                      onClick={(e) =>
                                        setCheckSuport(e.target.checked)
                                      }
                                      name="Suporte"
                                    />
                                  }
                                  label="Suporte"
                                />
                              </FormGroup>
                            </ListItem>
                          </div>
                          <div
                            className="form-cadastro"
                            style={{ padding: 20 }}
                          >
                            <div className="row">
                              <div className="col-md-4">
                                <h6>
                                  Relatório
                                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </h6>
                              </div>
                            </div>
                            <ListItemButton key={"dashboard"} role="listitem">
                              <FormGroup>
                                <FormControlLabel
                                  control={
                                    <Switch
                                      checked={checkDashboard ? true : false}
                                      onClick={(e) =>
                                        setCheckDashboard(e.target.checked)
                                      }
                                      name="Dashboard"
                                    />
                                  }
                                  label="Dashboard"
                                />
                              </FormGroup>
                            </ListItemButton>
                            <ListItem>
                              <FormGroup>
                                <FormControlLabel
                                  control={
                                    <Switch
                                      checked={checkDashboardScp ? true : false}
                                      onClick={(e) =>
                                        setCheckDashboardScp(e.target.checked)
                                      }
                                      name="Dashboard SCP"
                                    />
                                  }
                                  label="Dashboard SCP"
                                />
                              </FormGroup>
                            </ListItem>
                          </div>
                          <div
                            className="form-cadastro"
                            style={{ padding: 20 }}
                          >
                            <div className="row">
                              <div className="col-md-4">
                                <h6>
                                  Configuração
                                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </h6>
                              </div>
                            </div>
                            <ListItemButton key={"configuration"} role="listitem">
                              <FormGroup>
                                <FormControlLabel
                                  control={
                                    <Switch
                                      checked={checkConfiguration ? true : false}
                                      onClick={(e) =>
                                        setCheckConfiguration(e.target.checked)
                                      }
                                      name="Cadastrar Configuração"
                                    />
                                  }
                                  label="Cadastrar Configuração"
                                />
                              </FormGroup>
                            </ListItemButton>
                            <ListItemButton key={"configuration-list"} role="listitem">
                              <FormGroup>
                                <FormControlLabel
                                  control={
                                    <Switch
                                      checked={checkConfigurationList ? true : false}
                                      onClick={(e) =>
                                        setCheckConfigurationList(e.target.checked)
                                      }
                                      name="Listar Configuração"
                                    />
                                  }
                                  label="Listar Configuração"
                                />
                              </FormGroup>
                            </ListItemButton>
                            <ListItemButton key={"configuration-remove"} role="listitem">
                              <FormGroup>
                                <FormControlLabel
                                  control={
                                    <Switch
                                      checked={checkConfigurationRemove ? true : false}
                                      onClick={(e) =>
                                        setCheckConfigurationRemove(e.target.checked)
                                      }
                                      name="Excluir Configuração"
                                    />
                                  }
                                  label="Excluir Configuração"
                                />
                              </FormGroup>
                            </ListItemButton>
                          </div>
                          <div
                            className="form-cadastro"
                            style={{ padding: 20 }}
                          >
                            <div className="row">
                              <div className="col-md-4">
                                <h6>
                                  Financeiro
                                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </h6>
                              </div>
                            </div>
                            <ListItemButton key={"escrituracao-nota-fiscal"} role="listitem">
                              <FormGroup>
                                <FormControlLabel
                                  control={
                                    <Switch
                                      checked={checkEscrituracaoNotaFiscal ? true : false}
                                      onClick={(e) =>
                                        setCheckEscrituracaoNotaFiscal(e.target.checked)
                                      }
                                      name="Escrituração Nota Fiscal"
                                    />
                                  }
                                  label="Escrituração Nota Fiscal"
                                />
                              </FormGroup>
                            </ListItemButton>
                          </div>
                        </Card>
                      </div>

                      <div className="row" style={{ padding: 50 }}>
                        <div className="col-md-4"></div>
                        <div className="col-md-4"></div>
                        <div className="col-md-4">
                          {permission?.isinsert ? (
                            <Button
                              variant="contained"
                              onClick={id ? update : save}
                              sx={{ mr: 1 }}
                            >
                              <AddIcon /> {"Salvar"}
                            </Button>
                          ) : (
                            <div style={{ color: "red", fontSize: "12px", textAlign: "center" }}>
                              Sem permissão para salvar usuários
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </Paper>
              </div>
            </div>
          }
        />
      </Container>

      {/* Dialog de erro de permissão */}
      <ResponsiveDialog
        open={!!permissionError}
        handleClose={clearPermissionError}
        title={permissionError?.title || "Erro de Permissão"}
        message={permissionError?.message || "Você não tem permissão para acessar este recurso."}
        status={permissionError?.type || "warning"}
      />
    </>
  );
}
export default NewUser;
